import { Injectable } from '@angular/core';
import { ClientBaseApiService } from '../../../core/api/client-base-api.service';
import { environment } from '../../../../environments/environment';
import { HttpRequestTypes } from '../../../core/models/enums/http-request-types';
import { FarmDeviceDetailItem } from '../models/farm-device.model';

@Injectable({
  providedIn: 'root'
})
export class DetailService {

  constructor(private clientApiService: ClientBaseApiService) { }

  getDetail(sensorType: string, farmId: number) {
    let url = environment.baseApiUrl + "v2/api/farm/" + sensorType + "/information/" + farmId;
    return this.clientApiService.baseApiCall<any>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  deleteField(payload) {
    let url = environment.baseApiUrl + "v2/api/farm/delete/with/device";
    return this.clientApiService.baseApiCall<any>({ url: url, payload: payload, requestType: HttpRequestTypes.POST });
  }

  getDeviceCount() {
    let url = environment.baseApiUrl + "v2/api/farm/iot/count";
    return this.clientApiService.baseApiCall<any>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  selectSensorType(payload) {
    let url = environment.baseApiUrl + "v2/api/device/filiz/save/soilsensor/type";
    return this.clientApiService.baseApiCall<any>({ url: url, payload: payload, requestType: HttpRequestTypes.POST })
  }

  getSensorList(deviceId) {
    let url = environment.baseApiUrl + "v2/api/device/filiz/sensor/list?deviceId=" + deviceId;
    return this.clientApiService.baseApiCall<any>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  getFarmSharedList(tempFarmAttId){
    let url = environment.baseApiUrl + "v2/api/farm/shared/list/by/tfaId?tempFarmAttId=" + tempFarmAttId;
    return this.clientApiService.baseApiCall<any>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }
}
